/* eslint-disable */
<template>
  <!-- -------------Cart------------------ -->
  <div class="container-fluid pt-5 pb-5 bg-white">
    <h4>CART</h4>
    <div class="underline-green"></div>
    <br />
    <br />
    <!-- SHOW TABLE IF THERE IS ITEM IN CART -->
    <div class="table-responsive" v-if="cart.length">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>
              Product
              <span class="table_img_name">Images</span>
            </th>
            <th>Quantity</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in cart" :key="item.product.id">
            <td class="tbl_p_name">
              <b>{{ item.product.name }}</b>
              <img :src="item.product.image" />
            </td>
            <td class="tbl_qty">
              <button @click="decreaseQuantity(item)" class="btn btn-primary btn-sm">-</button>
              <span class="cart_qty_num mx-2">{{ item.quantity }} &nbsp;</span>
              <button @click="increaseQuantity(item)" class="btn btn-primary btn-sm">+</button>
            </td>
            <td>
              &#8358;{{ addComma(item.product.price * item.quantity) }}
              <div class="float-right delete_btn">
                <i
                  class="fa fa-trash"
                  aria-hidden="true"
                  @click="removeProductFromCart(item.product)"
                ></i>
              </div>
            </td>
          </tr>
          <tr>
            <td class="text-right" colspan="2">
              <strong>Subtotal</strong>
            </td>
            <td colspan="2">&#8358;{{ addComma(cartTotalPrice) }}</td>
          </tr>
          <tr>
            <td class="text-right" colspan="2">
              <strong>Taxes</strong>
            </td>
            <td colspan="2">&#8358;{{ addComma(taxAmount) }}</td>
          </tr>
          <tr>
            <td class="text-right" colspan="2">
              <strong>Total</strong>
            </td>
            <td
              class="cart_overal_total"
              colspan="2"
            >&#8358;{{ addComma(cartTotalPrice + taxAmount) }}</td>
          </tr>
          <tr>
            <td class="text-right pt-1" colspan="3">
              <p v-if="couponCodeError" class="lead coupon_text text-danger">{{errorNote}}</p>
              <form
                @submit.prevent="addCoupon"
                class="form-inline float-right"
                id="form-coupon-code"
              >
                <input type="text" class="form-control" v-model="coupon" placeholder="Coupon code" />
                <button class="btn btn-primary ml-2 font-weight-bold">SUBMIT</button>
              </form>
            </td>
          </tr>
          <tr class="tbl_control_btn">
            <td>
              <button class="btn checkout_btn btn-danger" @click="clearCart">Clear</button>
            </td>
            <td class="text-right" colspan="2">
              <button
                class="checkout_btn btn btn-success"
                @click="proceedToCheckout"
              >Proceed to checkout</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- IF NO ITEM IN CART -->
    <div class="card no-cart" v-else>
      <div class="card-body">
        <p class="lead">Your cart is currently empty</p>
      </div>
    </div>
    <!-- SHOW LOADING -->
    <LoadingComponent v-if="loading" />
    <transition name="fade">
      <Loading v-if="isloading" />
    </transition>
  </div>
</template>

<script>
import LoadingComponent from "../components/LoadingComponent";
import Loading from "../components/Loading";
export default {
  name: "Cart",
  components: {
    LoadingComponent,
    Loading
  },
  data() {
    return {
      couponCodeError: false,
      coupon: "",
      errorNote: "",
      loading: true
    };
  },
  computed: {
    // GET ITEM IN CART
    cart() {
      return this.$store.state.cart;
    },
    // GET TOTAL PRICE OF ITEM
    cartTotalPrice() {
      return this.$store.getters.cartTotalPrice;
    },
    // TAX AMOUNT
    taxAmount() {
      let tax = (this.cartTotalPrice * 10) / 600;
      let taxAmount = Math.trunc(tax);
      return taxAmount;
    },
    isloading() {
      return this.$store.state.isloading;
    }
  },
  mounted() {
    this.processLoading();
    this.$store.state.showSearch = false;
  },
  methods: {
    // INCREASE QUANTITY
    increaseQuantity: function(item) {
      this.$store.state.isloading = true;
      setTimeout(() => {
        this.$store.state.isloading = false;
        item.quantity++;
      }, 1500);
    },
    // REDUCE QUANTITY
    decreaseQuantity: function(item) {
      this.$store.state.isloading = true;
      setTimeout(() => {
        this.$store.state.isloading = false;
        item.quantity--;
        if (item.quantity == 0) {
          this.removeItemFromCart(item);
        }
      }, 1500);
    },
    // REMOVE ITEM FROM CART
    removeItemFromCart: function(item) {
      var index = this.$store.state.cart.indexOf(item);
      this.$store.state.isloading = true;
      setTimeout(() => {
        this.$store.state.isloading = false;
        if (index !== -1) {
          this.$store.state.cart.splice(index, 1);
        }
      }, 1500);
    },
    removeProductFromCart: function(product) {
      this.$store.state.isloading = true;
      setTimeout(() => {
        this.$store.state.isloading = false;
        this.$store.dispatch("removeProductFromCart", product);
      }, 1500);
    },
    // CLEAR CART
    clearCart: function() {
      this.$store.state.isloading = true;
      this.couponCodeError = false;
      this.coupon = "";
      setTimeout(() => {
        this.$store.state.isloading = false;
        this.clearCartState();
      }, 3000);
    },
    // PROCEED TO CHECKOUT PAGE
    proceedToCheckout: function() {
      this.$store.state.isloading = true;
      setTimeout(() => {
        this.$store.state.isloading = false;
        this.AddToState();
      }, 2600);
    },
    // ADD INFORMATION FROM FORM AND STORE IN OUR STATE
    AddToState: function() {
      this.couponCodeError = false;
      this.coupon = "";
      if (this.$store.state.cart.length > 0) {
        this.$store.dispatch("setCheckout");
        let amount = this.cartTotalPrice + this.taxAmount;
        let totalAmountTopay = Math.trunc(amount) * 100;
        this.$store.state.amount = totalAmountTopay;
        this.$router.push("/checkout");
      }
    },
    // CLEAR ALL CART STATE
    clearCartState: function() {
      this.$store.dispatch("clearCart");
    },
    // PROCESS COUON CODE
    addCoupon: function() {
      this.$store.state.isloading = true;
      setTimeout(() => {
        this.$store.state.isloading = false;
        this.processCoupon();
      }, 2600);
    },
    processCoupon: function() {
      this.couponCodeError = true;
      if (!this.coupon) {
        this.errorNote = "Please provide a code";
      } else {
        this.errorNote = "Sorry! Coupon code not found";
      }
    },
    // ADD COMMA TO AMOUNT
    addComma: function(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // PROCESS LOADING
    processLoading: function() {
      this.loading = true;
      setTimeout(() => this.closeLoading(), 3000);
    },
    // CLOSE LOADING
    closeLoading: function() {
      if (this.loading) {
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>
